var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Yup from "yup";
import debounce from "debounce-promise";
//Default error messages
const errMsg = {
    required: "This field is required",
    max: "Length is too long",
    zip: "Sorry. We don't deliver to your area",
    zipLong: "Sorry. We don't deliver to your area. Please re-select or enter a new address below."
};
function checkDeliveryPostcode(zip) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`/ajax/checkDeliveryPostcode?pcode=${zip}`);
        const data = yield response.json();
        return data.can_deliver;
    });
}
const debounceCheckDeliveryPostcode = debounce(checkDeliveryPostcode, 450);
export const checkoutSchema = Yup.object().shape({
    same_addresses: Yup.boolean(),
    billing_address_id: Yup.string().when("same_addresses", {
        is: true,
        then: () => Yup.string().max(20, errMsg.max).required(errMsg.required).test("validateZip", errMsg.zipLong, function (value) {
            const { addressList, isCollection } = this.parent;
            //If customer collects, or manually enters address, validation PASSES
            if (isCollection || value == "-1")
                return true;
            //Find the selected address.. If one isn't selected return TRUE (should never be the case, but pleases TS)
            const selectedAddress = addressList.find(a => a.id.toString() == value);
            if (!selectedAddress)
                return true;
            //Return if deliverable or not
            return selectedAddress.deliverable;
        })
    }),
    shipping_address_id: Yup.string().when("same_addresses", {
        is: false,
        then: () => Yup.string().max(20, errMsg.max).required(errMsg.required).test("validateZip", errMsg.zipLong, function (value) {
            const { addressList, isCollection } = this.parent;
            //If customer collects, or manually enters address, validation PASSES
            if (isCollection || value == "-1")
                return true;
            //Find the selected address.. If one isn't selected return TRUE (should never be the case, but pleases TS)
            const selectedAddress = addressList.find(a => a.id.toString() == value);
            if (!selectedAddress)
                return true;
            //Return if deliverable or not
            return selectedAddress.deliverable;
        })
    }),
    billing_firstname: Yup.string().max(128, errMsg.max).when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_lastname: Yup.string().max(128, errMsg.max).when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_address1: Yup.string().max(128, errMsg.max).when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_address2: Yup.string().max(128, errMsg.max),
    billing_city: Yup.string().max(128, errMsg.max).when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_state: Yup.string().when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_postcode: Yup.string().when(["same_addresses", "billing_address_id"], {
        is: (same_addresses, billing_address_id) => same_addresses == true && billing_address_id == "-1",
        then: () => Yup.string().max(20, errMsg.max).required(errMsg.required).test("validateZip", errMsg.zip, function (value) {
            return __awaiter(this, void 0, void 0, function* () {
                const zip = value;
                const useSameAddress = this.parent.same_addresses;
                const isCollection = this.parent.isCollection;
                //If user is collecting, or we're using seperate shipping address, return true
                if (isCollection || !useSameAddress)
                    return true;
                return yield debounceCheckDeliveryPostcode(zip);
            });
        }),
        otherwise: () => Yup.string().max(20, errMsg.max)
    }),
    billing_phone: Yup.string().max(30, errMsg.max).when("billing_address_id", { is: "-1", then: () => Yup.string().required(errMsg.required) }),
    billing_delivery: Yup.string().max(255, errMsg.max),
    shipping_firstname: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(128, errMsg.max).required(errMsg.required),
        otherwise: () => Yup.string().max(128, errMsg.max)
    }),
    shipping_lastname: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(128, errMsg.max).required(errMsg.required),
        otherwise: () => Yup.string().max(128, errMsg.max)
    }),
    shipping_address1: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(128, errMsg.max).required(errMsg.required),
        otherwise: () => Yup.string().max(128, errMsg.max)
    }),
    shipping_address2: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(128, errMsg.max),
        otherwise: () => Yup.string().max(128, errMsg.max)
    }),
    shipping_city: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(128, errMsg.max).required(errMsg.required),
        otherwise: () => Yup.string().max(128, errMsg.max)
    }),
    shipping_state: Yup.string().max(128, errMsg.max),
    shipping_postcode: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(20, errMsg.max).required(errMsg.required).test("validateZip", errMsg.zip, function (value) {
            return __awaiter(this, void 0, void 0, function* () {
                const zip = value;
                const useSameAddress = this.parent.same_addresses;
                const isCollection = this.parent.isCollection;
                //If user is collecting, or using billing address return TRUE
                if (isCollection || useSameAddress)
                    return true;
                return yield debounceCheckDeliveryPostcode(zip);
            });
        }),
        otherwise: () => Yup.string().max(20, errMsg.max)
    }),
    shipping_phone: Yup.object().when(["same_addresses", "shipping_address_id"], {
        is: (same_addresses, shipping_address_id) => same_addresses == false && shipping_address_id == "-1",
        then: () => Yup.string().max(30, errMsg.max).required(errMsg.required),
        otherwise: () => Yup.string().max(30, errMsg.max)
    }),
});
